import apiClient from "./client";

/** Public: active rows with non-empty fileUrl, ordered by displayOrder then id. */
export const getCompanyProfilePdfs = async () => {
  const response = await apiClient.get("/company-profile/pdfs");
  return response.data;
};
